import { ProgressBarInfo } from '@apply/components';
import { LoanType } from '../../../../../../../../../common/constants/LoanType';
import { SetupForm } from '../../../SetupAndBorrower/Setup/constants/setupForm';
import { isRequiredOnceNoteDated } from '../../../SetupAndBorrower/Setup/functions/isRequiredOnceNoteDated';
import { LoanForm } from '../constants/loanForm';

/** Completion for the Loan step: its amounts and Interest Rate are required once the loan has a Note Date. */
export const getLoanProgress = (form: LoanForm, setup: SetupForm): ProgressBarInfo => {
    const fieldsComplete: boolean[] = [];
    if (isRequiredOnceNoteDated(setup)) {
        fieldsComplete.push(!!form.promissoryNote, !!form.commitment, !!form.interestRate);
        if (setup.loanTypeId === LoanType.Bridge) {
            // 0 is a valid Bridge Funded amount
            fieldsComplete.push(form.bridgeFunded !== undefined);
        }
    }
    return {
        numberComplete: fieldsComplete.filter(Boolean).length,
        total: fieldsComplete.length,
    };
};
